import pathsToday from './paths-today.png'
import pathsLater from './paths-later.png'

const content = `<p>Why is software design important?</p>

<p>Good software design enables code to be easy, cheap and fast to change.</p>

<p>If you make a choice that makes the code easier to change, this is good design. If you make a choice that makes the code harder to change, this is bad design. It’s as simple as this.</p>

<p>There are many things that lie in front of your application in the future, but you don’t know exactly what they are made of. You don’t know the features your user will require, you don’t know the technical constraints you will come up against, you don’t know what the next global crisis will be about.</p>

<p>It’s like if there were many possible paths ahead of you for your application to take:</p>

<img src=${pathsToday} alt="paths-today" />

<p>As time passes, the application has to change. At some point in time one of the possible futures comes to be, but many more other possible futures lie ahead. It’s a continuous process:</p>

<img src=${pathsLater} alt="paths-later" />

<p>Software design is what allows you to always leave options open for the future, so that you can make your application react to the needs you encounter as they happen, even if you can’t know them in advance.</p>

<p>If your code is well designed, it means that it’s easy to change, and you can make it navigate the requirements that will happen in the future whenever you need it.</p>

<p>The better the design the faster it is to change the code to choose any next move. The worse the design, the more costly it becomes with time to accommodate a new requirement.</p>

<p>How about making code easier to&nbsp;<em>understand</em>? Isn’t that what good design it about?</p>

<p>Making code <a href="/expressive-code">easier to understand</a> is very important because it makes it easier to change and reason about. But it’s not an end goal, as understanding code in itself doesn’t bring money to the business. Changing the code does.</p>

<p>Also, an interesting corollary is that implementing a cool design pattern or technique is nice, but only if it makes the code easier to change. If it doesn’t, this is just additional complexity for nothing.</p>

<p>All the software design principles and techniques relate to making the code changeable.</p>

<p>Now, how <em>do we make</em> the code easy to change? A good place to start is by writing code that has <a href="/low-coupling">Low coupling</a>.</p>`

export default content
